import { Component } from "@angular/core";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { FuncionamientosDTO } from "src/app/models/funcionaminetos.dto";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { FuncionamientoService } from "./funcionamiento.service";
import { FuncionamientoDrawerForm } from "./drawer-form/drawer-form.component";
import { DrawerService } from "src/app/services/drawer.service";

@Component({
  selector: "app-funcionamiento",
  templateUrl: "./funcionamiento.component.html",
  styles: [],
})
export class FuncionamientoComponent extends CrudComponent<FuncionamientosDTO> {
  columnId: string = "IdFuncionamiento";
  public columns: ListColumn[] = [
    {
      name: "Desc",
      property: "Descripcion",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  realdata: any[];

  constructor(
    public service: FuncionamientoService,
    private layoutService: LayoutsService,
    public alerts: AlertasSwalService,
    public drawer: DrawerService
  ) {
    super(service, alerts);
  }

  ngOnInit(): void {
    this.loadRecords();
    this.layoutService.changeHeader("Funcionamiento");
    this.filter = new Filter<FuncionamientosDTO>(
      this.conditions,
      this.columns,
      true
    );
    this.filter.setColumnActive(this.columnActive);
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<FuncionamientosDTO>;
  public conditions: Condition<FuncionamientosDTO> = {
    Descripcion: (o, f) =>
      (o.Descripcion ?? "").toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter
    openUser() {
      const drawerRef = this.drawer.open({
        component: FuncionamientoDrawerForm,
        data: { mode: "create", value: {} },
        width: "500px",
        title: "Funcionamientos",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Guardar",
            action: (component: FuncionamientoDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }

    override openEdit(value: any) {
      const drawerRef = this.drawer.open({
        component: FuncionamientoDrawerForm,
        data: { mode: "update", value: value },
        width: "500px",
        title: "Funcionamientos",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Actualizar",
            action: (component: FuncionamientoDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }
    public tableActionsCC = [
      {
        label: "Nuevo",
        icon: "plus",
        className:
          "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
        action: () => this.openUser(),
      },
    ];
}
